/* eslint-disable lingui/no-unlocalized-strings */ function getSsoMethodKey(method) {
    return `sso:${method.connection_id}`;
}
function extractConnectionId(method) {
    return method?.startsWith('sso:') ? method.slice(4) : undefined;
}
function getButtonKey(button) {
    if (button.type === 'oauth') {
        return button.provider.type;
    } else if (button.type === 'sso') {
        return getSsoMethodKey(button.connection);
    } else {
        return 'sso-discovery';
    }
}

export { extractConnectionId, getButtonKey, getSsoMethodKey };
//# sourceMappingURL=authMethodKeys.mjs.map
